<template>
  <div
    id="filter-wrapper"
    v-click-outside="clickOutside"
    class="filter-dropdown-parent"
  >
    <div class="filter-selector"
         @click="showDropdown = !showDropdown"
    >
      <span class="filter-label">{{ filterName }}</span>
      <span class="selected-filter">{{ readableFilter }}</span>
      <span class="down-arrow">&#9660;</span>
    </div>
    <div v-show="showDropdown"
         class="filter-dropdown"
    >
      <div class="filter-list">
        <div v-if="filterType === 'status'">
          <div class="checkbox-parent">
            <v-checkbox
              @change="changeStatus"
            >
              Online
            </v-checkbox>
          </div>
          <div class="checkbox-parent">
            <v-checkbox
              @change="changeStatus"
            >
              Offline
            </v-checkbox>
          </div>
        </div>
        <div
          v-for="filter in filters"
          v-else
          :key="filter.name"
          class="checkbox-parent"
        >
          <v-checkbox
            :class="{ 'no-value': !filter.name }"
            @change="changeFilter"
          >
            {{ filter.name ? filter.name : "- undefined" }}
          </v-checkbox>
        </div>
      </div>
      <hr>
      <div class="dropdown-footer">
        <a href="#"
           @click="clearFilter"
        >CLEAR</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import vClickOutside from 'v-click-outside'

@Component({
  directives: {
    clickOutside: vClickOutside.directive
  }
})
export default class FilterDropdown extends Vue {
  @Prop()
  filterName!: string;

  @Prop()
  filterType!: string;

  @Prop()
  selectedFilter!:string[];

  @Prop()
  filters!: { name: string; count: number }[];

  showDropdown = false;

  get selectedStatus (): string[] {
    if (typeof this.selectedFilter === 'string') {
      return [this.selectedFilter]
    }
    return this.selectedFilter
  }

  get readableFilter (): string {
    if (typeof this.selectedFilter === 'string') {
      return this.selectedFilter ? this.selectedFilter : 'All'
    }
    return this.selectedFilter && this.selectedFilter.length > 0 ? this.selectedFilter.join() : 'All'
  }

  changeStatus (event: { detail: { checked: boolean; value: string } }): void {
    let newValue: string[]
    if (event.detail.checked) {
      newValue = [event.detail.value]
    } else {
      newValue = []
    }

    this.$emit('update-filter', this.filterType, newValue)
  }

  changeFilter (event: { detail: { checked: boolean; value: string } }): void {
    let newValue: string[]
    if (event.detail.checked) {
      newValue = [...this.selectedFilter, event.detail.value]
    } else {
      newValue = this.selectedFilter.filter((filter) => filter !== event.detail.value)
    }

    this.$emit('update-filter', this.filterType, newValue)
  }

  clearFilter (): void {
    this.selectedFilter = []
    this.$emit('update-filter', this.filterType, [])
  }

  clickOutside (): void {
    this.showDropdown = false
  }
}
</script>

<style lang="scss">
// no SCOPED because checkboxes need to be changed
#filter-wrapper {
  position: relative;

  .io_text.sc-io-checkbox.sc-io-checkbox-s {
    font-family: $primary-font !important;
    font-size: 14px !important;
  }

  &.filter-dropdown-parent {
    margin-right: 30px;
    margin-bottom: 20px;
  }

  .checkbox-parent {
    .no-value {
      color: $pale-purple;
    }

    io-checkbox label {
      padding-left: 5px;
      font-weight: normal;
    }

    .io_checkmark.sc-io-checkbox {
      min-width: 16px;
      height: 16px;
      margin-top: 8px;
      border: 2px solid $pale-purple;
      font-family: $primary-font;

      &.io_checkmark--checked {
        border: 2px solid $highlight-colour;
      }
    }

    .io_checkmark {
      margin-right: 10px;
    }

    .sc-io-checkbox-h .io_text.sc-io-checkbox {
      padding: 10px;
    }
  }

  .filter-selector {
    cursor: pointer;
    display: inline-flex;

    .selected-filter {
      margin-right: 5px;
      margin-left: 10px;
      max-width: 100px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .down-arrow {
      font-size: 10px;
      align-content: flex-start;
    }

    .filter-label {
      cursor: pointer;
      font-weight: bold;
    }
  }

  .filter-checkobox {
    padding: 10px;
  }

  .filter-label {
    io-icon {
      margin-right: 10px;
    }

    span {
      font-size: 14px;
      line-height: 30px;
      margin-left: 5px;
      cursor: pointer;
    }

    display: inline-flex;
    margin-left: auto;
  }

  .filter-dropdown {
    background-color: white;
    z-index: 100;
    position: absolute;
    padding: 10px 10px 0 18px;
    width: 233px;
    border: solid 1px #f6f5f5;
    box-shadow: 1px 8px 16px 0 rgba(176, 192, 237, 0.16),
      0 2px 6px 0 rgba(115, 125, 155, 0.16);

    .filter-list {
      max-height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    hr {
      position: absolute;
      border-top: $pale-purple;
      left: 0;
      width: 100%;
      margin: 1px 0 1px 0;
      box-shadow: 1px 8px 16px 0 rgba(176, 192, 237, 0.16),
        0 2px 6px 0 rgba(115, 125, 155, 0.16);
    }

    .dropdown-footer {
      position: sticky;
      display: flex;
      justify-content: space-around;
      padding: 10px;

      a {
        color: $pale-purple;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
